import React from "react";
import { Avatar, Card, Typography, Grid, Box } from "@mui/material";
import moment from "moment";

const ActivityRemarks = ({ remarksData }) => {
  console.log("remarksData", remarksData);
  const toTitleCase = (str) => {
    return str
      .replace(/([A-Z])/g, " $1")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Grid container spacing={2}>
      {remarksData.map((item) => {
        const actionData = JSON.parse(item.Action);
        const AttachmentData = JSON.parse(item.AttachmentLink);
        console.log("AttachmentData", AttachmentData);
        const { currentStatus, changedData, activityType } = actionData || {};
        const changedEntries = changedData ? Object.entries(changedData) : [];
        const avatarLetter = item.created_by
          ? item.created_by[0].toUpperCase()
          : "S";

        return (
          <Grid item xs={12} key={item.RemarkID}>
            <Card variant="outlined" style={{ padding: "16px" }}>
              <Box display="flex" alignItems="center" mb={2}>
                <Avatar>{avatarLetter}</Avatar>
                <Typography variant="h6" style={{ marginLeft: "16px" }}>
                  {activityType} updated the Activity:{" "}
                  {changedEntries.some(([key, value]) => key === "status") ? (
                    <>
                      {currentStatus} → {changedData.status}
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </Box>
              {changedEntries.length > 0 ? (
                changedEntries.map(([key, value]) => (
                  <React.Fragment>
                    {value != "-" &&
                      key != "status" &&
                      key != "attachments" &&
                      key != "attachment" && (
                        <Typography key={key} variant="subtitle1" gutterBottom>
                          <strong>
                            {toTitleCase(key.replace(/([A-Z])/g, " $1").trim())}
                            :
                          </strong>{" "}
                          {value || "N/A"}
                        </Typography>
                      )}
                  </React.Fragment>
                ))
              ) : (
                <Typography variant="subtitle1" gutterBottom></Typography>
              )}
              {AttachmentData && (
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  flexWrap={"wrap"}
                  mr={1}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>Attachments: </strong>
                  </Typography>{" "}
                  {AttachmentData &&
                    AttachmentData?.map((attachment, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{
                              marginLeft: 1,
                              marginRight: 1,
                              marginBottom: 1,
                            }}
                          >
                            <a
                              href={attachment.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {attachment.name}
                            </a>
                          </Typography>
                        </React.Fragment>
                      );
                    })}
                </Box>
              )}
              <Typography variant="body2" color="textSecondary">
                {moment(item.created_at).format("M/D/YYYY, h:mm:ss A")}
              </Typography>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ActivityRemarks;
